const nl = {
  common: {
    loading: "Laden...",
    back: "Terug",
    next: "Volgende",
    save: "Opslaan",
    cancel: "Annuleren",
    close: "Sluiten",
    send: "Versturen",
    submit: "Indienen",
    yes: "Ja",
    no: "Nee",
    error: "Fout",
    success: "Succes",
    search: "Zoeken",
    more: "Meer",
    less: "Minder",
    optional: "optioneel",
    required: "Verplicht",
    perMonth: "/ maand",
    oneTime: "eenmalig",
    free: "Gratis",
    skip: "Overslaan",
    pleaseWait: "Even geduld...",
    backToHome: "Terug naar startpagina",
    learnMore: "Meer informatie",
    email: "E-mail",
    phone: "Telefoon",
    password: "Wachtwoord",
    name: "Naam",
    selected: "geselecteerd",
    available: "beschikbaar",
    used: "gebruikt",
    of: "van",
    question: "Vraag",
    craftBusiness: "Ambachtsbedrijf",
    forCraftBusinesses: "Voor ambachtsbedrijven",
    projectInquiry: "Projectaanvraag",
    projectInquiries: "Projectaanvragen",
  },
  header: {
    dashboard: "Dashboard",
    signOut: "Uitloggen",
    completeProfile: "Profiel voltooien",
    submitInquiry: "Projectaanvraag indienen",
    signIn: "Inloggen",
    menuOpen: "Menu openen",
    menuClose: "Menu sluiten",
    registerAsCraft: "Registreren als ambachtsbedrijf",
  },
  footer: {
    tagline: "Gekwalificeerde projectaanvragen.\nVoor geselecteerde ambachtsbedrijven.",
    motto: "Vinden \u00B7 Verbinden \u00B7 Bouwen",
    platform: "Platform",
    findCraft: "Ambachtsbedrijf vinden",
    submitInquiry: "Projectaanvraag indienen",
    forCraftBusinesses: "Voor ambachtsbedrijven",
    aboutUs: "Over ons",
    legalAndContact: "Juridisch & Contact",
    imprint: "Colofon",
    privacy: "Privacy",
    accessibility: "Toegankelijkheid",
    contact: "Contact",
    copyright: "\u00A9 {{year}} CRAFTFINDUS. Voor ambachtsbedrijven in Duitsland, Oostenrijk en Zwitserland.",
  },
  cookies: {
    title: "Wij gebruiken cookies",
    description: "Wij gebruiken cookies om u de best mogelijke ervaring op onze website te bieden. Meer informatie in onze",
    privacyLink: "Privacyverklaring",
    acceptAll: "Alles accepteren",
    configure: "Configureren",
    saveSelection: "Selectie opslaan",
    onlyNecessary: "Alleen noodzakelijke",
    necessary: "Noodzakelijk",
    necessaryDesc: "Vereist voor de werking van de website.",
    analytics: "Analyse",
    analyticsDesc: "Helpen ons te begrijpen hoe de website wordt gebruikt.",
    marketing: "Marketing",
    marketingDesc: "Maken gepersonaliseerde advertenties mogelijk.",
  },
  mobileCta: {
    submitInquiry: "Aanvraag indienen",
    craftBusiness: "Ambachtsbedrijf",
  },
  floatingPhone: {
    question: "Heeft u vragen? Bel ons gerust:",
    ariaLabel: "Telefoonnummer tonen",
  },
  home: {
    seoTitle: "Ambachtsbedrijf vinden & projectaanvragen ontvangen",
    seoDesc: "CRAFTFINDUS: Vind gratis het juiste ambachtsbedrijf of ontvang als ambachtsman gekwalificeerde projectaanvragen. Intelligent gematcht, 3 tot 5 bedrijven per project.",
    heroLabel: "Het ambachtsplatform voor uw project",
    heroTitle1: "De juiste",
    heroTitle2: "ambachtsman vinden.",
    heroTitle3: "Zonder eindeloos zoeken.",
    heroDesc: "Beschrijf uw project. Wij vinden 3 tot 5 passende ambachtsbedrijven voor u. Gratis, binnen 24 uur.",
    heroCta: "Gratis ambachtsman vinden",
    heroCtaCraft: "Ik ben een ambachtsbedrijf",
    badge100Free: "100% gratis",
    badgeResponse: "Antwoord binnen <24u",
    badgeVerified: "Geverifieerde ambachtsbedrijven",
    tradesLabel: "Uw project, ons netwerk",
    tradesTitle: "Vind de juiste ambachtsman voor elk vak",
    tradesDesc: "Of het nu reparatie, nieuwbouw of renovatie is \u2013 {{brand}} vindt het juiste bedrijf bij u in de buurt.",
    tradesCta: "Nu gratis ambachtsman vinden",
    electrician: "Elektricien",
    electricianDesc: "Elektra-installatie, verlichting, zekeringkasten, smart home \u2013 vind een elektricien bij u in de buurt.",
    plumbing: "Sanitair & Verwarming",
    plumbingDesc: "Badkamerrenovatie, verwarmingsvervanging, leidingwerk \u2013 professionele installateurs voor uw project.",
    roofing: "Dakdekkers & Timmerlieden",
    roofingDesc: "Dakrenovatie, dakramen, dakconstructie \u2013 ervaren dakdekkers voor veilige oplossingen.",
    painting: "Schilders & Vloerenleggers",
    paintingDesc: "Gevelschildering, behangen, vloerbedekking \u2013 creatieve vakmensen voor mooie ruimtes.",
    solar: "Zonne-energie & Klimaat",
    solarDesc: "Zonnepanelen, warmtepompen, airconditioning \u2013 duurzame energieoplossingen van specialisten.",
    construction: "Bouw & Interieur",
    constructionDesc: "Droogbouw, tegelwerk, complete renovatie \u2013 alles uit \u00E9\u00E9n hand.",
    howLabel: "3 eenvoudige stappen",
    howTitle: "Zo vindt u de juiste ambachtsman",
    howDesc: "Geen eindeloos zoeken. Geen eindeloze telefoontjes. Wij begeleiden u door het proces.",
    step1Title: "Project beschrijven",
    step1Desc: "Beantwoord een paar eenvoudige vragen \u2013 bijv. 'Badkamer renoveren' of 'Zonnepanelen installeren'.",
    step2Title: "Ambachtslieden worden geselecteerd",
    step2Desc: "{{brand}} vindt automatisch tot 5 ambachtsbedrijven die bij uw project passen door intelligent matching. Uit uw regio, met de juiste ervaring.",
    step3Title: "U wordt gecontacteerd",
    step3Desc: "De geselecteerde bedrijven nemen rechtstreeks contact met u op, persoonlijk, niet per massae-mail. U beslist wie het beste past.",
    benefitsLabel: "Voordelen",
    benefitsTitle: "E\u00E9n platform, twee winnaars",
    forClients: "Voor opdrachtgevers",
    clientsTitle: "Ambachtsman vinden: eenvoudig & gratis",
    clientFree: "Volledig gratis",
    clientFreeDesc: "Geen kosten, geen commissie. U betaalt alleen uw ambachtsman.",
    clientNoJargon: "Geen vakjargon nodig",
    clientNoJargonDesc: "Beschrijf uw project in eigen woorden. Wij vinden de juiste vakgebieden.",
    clientFast: "Snelle reacties",
    clientFastDesc: "Binnen 24 uur nemen 3 tot 5 passende ambachtsbedrijven contact met u op.",
    clientQuality: "Geverifieerde kwaliteit",
    clientQualityDesc: "Alle bedrijven zijn geverifieerd. Meesterbedrijven worden extra uitgelicht.",
    clientCta: "Gratis aanvraag indienen",
    forProviders: "Voor ambachtsbedrijven",
    providersTitle: "Gekwalificeerde projectaanvragen, zonder moeite",
    providerMatched: "Passende projecten",
    providerMatchedDesc: "Alleen aanvragen die bij uw vak, regio en capaciteit passen.",
    providerCompetitors: "Max. 3 tot 5 concurrenten",
    providerCompetitorsDesc: "Geen massaplatform. Eerlijke kansen door intelligente beperking.",
    providerTransparent: "Transparante kosten",
    providerTransparentDesc: "Een vaste prijs per projectaanvraag. Geen maandelijkse kosten, geen commissies.",
    providerRate: "Hoog acceptatiepercentage",
    providerRateDesc: "Omdat de matching werkt: hoge kwaliteit, weinig verspilling.",
    providerCta: "Registreren als ambachtsbedrijf",
    principlesTitle: "Waarom {{brand}}?",
    principle1Num: "01",
    principle1Title: "Niet zoeken, niet vergelijken",
    principle1Desc: "Wij tonen geen eindeloze lijsten. Ons algoritme selecteert de juiste bedrijven voor u \u2013 op basis van data, niet toeval.",
    principle2Num: "02",
    principle2Title: "Kwaliteit boven kwantiteit",
    principle2Desc: "Maximaal 3 tot 5 ambachtsbedrijven per project. Zo krijgt u echte aandacht, geen copy-paste offertes.",
    principle3Num: "03",
    principle3Title: "Transparant & eerlijk",
    principle3Desc: "Iedereen weet waarom een match tot stand komt. Geen bieden, geen prijsdumping. Eerlijke voorwaarden voor beide partijen.",
    statsTitle: "{{brand}} in cijfers",
    stat1Value: "3-5",
    stat1Label: "Bedrijven per project",
    stat2Value: "12+",
    stat2Label: "Vakgebieden beschikbaar",
    stat3Value: "<24u",
    stat3Label: "Reactietijd",
    stat4Value: "\u20AC0",
    stat4Label: "Kosten voor opdrachtgevers",
    faqLabel: "FAQ",
    faqTitle: "Veelgestelde vragen",
    faqDesc: "Antwoorden voor opdrachtgevers en ambachtsbedrijven.",
    faqForClients: "Voor opdrachtgevers",
    faqForProviders: "Voor ambachtsbedrijven",
    faqC1Q: "Ik heb een vakman nodig, maar weet niet precies welk vak. Is CRAFTFINDUS geschikt?",
    faqC1A: "Ja, absoluut! CRAFTFINDUS is precies hiervoor gemaakt. Beschrijf gewoon uw project – wij vinden het juiste vak en de beste bedrijven voor u. Helemaal gratis.",
    faqC2Q: "Wat kost het om een vakman te zoeken?",
    faqC2A: "Voor u als opdrachtgever is CRAFTFINDUS volledig gratis. U plaatst uw projectaanvraag, ontvangt 3 tot 5 passende ambachtsbedrijven en beslist zelf met wie u samenwerkt. Geen verborgen kosten.",
    faqC3Q: "Hoe snel krijg ik antwoord op mijn projectaanvraag?",
    faqC3A: "Doorgaans nemen gekwalificeerde ambachtsbedrijven binnen 24 uur contact met u op. Bij dringende aanvragen vaak nog sneller. U ontvangt maximaal 3 tot 5 offertes – zorgvuldig geselecteerd.",
    faqC4Q: "Welke projecten kan ik via CRAFTFINDUS aanvragen?",
    faqC4A: "Vrijwel alle ambachtsprojecten: elektra, loodgieterij, verwarming, dakwerk, interieurafwerking, zonnepanelen, airconditioning, schilderwerk en nog veel meer.",
    faqP1Q: "Wat biedt CRAFTFINDUS mij als ambachtsbedrijf?",
    faqP1A: "U ontvangt voorgekwalificeerde projectaanvragen die passen bij uw vak en regio. Maximaal 3 tot 5 bedrijven per aanvraag betekent: minder concurrentie, hogere sluitingspercentages.",
    faqP2Q: "Hoe werkt de matching bij CRAFTFINDUS?",
    faqP2A: "Ons algoritme analyseert elke projectaanvraag en matcht deze met uw profiel: vak, specialisatie, regio, beschikbaarheid en projectomvang.",
    faqP3Q: "Wat kost CRAFTFINDUS voor ambachtsbedrijven?",
    faqP3A: "U betaalt alleen een transparante, vaste prijs per geaccepteerde projectaanvraag. Geen maandelijkse kosten, geen commissies op uw opdrachten.",
    faqP4Q: "Wat onderscheidt CRAFTFINDUS van andere vakmanportalen?",
    faqP4A: "Geen bieden, geen prijsdumping. Bij CRAFTFINDUS worden ambachtsbedrijven geselecteerd, niet gezocht. De limiet van 3 tot 5 bedrijven per aanvraag garandeert eerlijke kansen.",
    ctaLabel: "Nu beginnen",
    ctaTitle: "Wat is op u van toepassing?",
    ctaClientTitle: "Ik zoek een ambachtsman",
    ctaClientDesc: "Beschrijf uw project. Wij vinden gratis de juiste ambachtsbedrijven voor u.",
    ctaClientBtn: "Gratis aanvraag indienen",
    ctaProviderTitle: "Ik ben een ambachtsbedrijf",
    ctaProviderDesc: "Ontvang voorgekwalificeerde projectaanvragen die bij uw profiel passen. Zonder bieden, zonder prijzenoorlog.",
    ctaProviderBtn: "Nu registreren",
  },
  auth: {
    seoTitle: "Inloggen \u2013 Ambachtsbedrijf portaal",
    seoDesc: "Log in bij CRAFTFINDUS \u2013 het exclusieve portaal voor gekwalificeerde ambachtsbedrijven.",
    backToHome: "Terug naar startpagina",
    loginPrompt: "Log in op uw account",
    emailLabel: "E-mail",
    emailPlaceholder: "uw@email.nl",
    passwordLabel: "Wachtwoord",
    passwordPlaceholder: "\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022",
    loginBtn: "Inloggen",
    invalidCredentials: "Ongeldige inloggegevens. Controleer uw invoer.",
    alreadyRegistered: "Dit e-mailadres is al geregistreerd.",
    registrationSuccess: "Registratie geslaagd! Bevestig uw e-mail.",
    loginSuccess: "Succesvol ingelogd",
    invalidEmail: "Voer een geldig e-mailadres in",
    passwordMin: "Wachtwoord moet minimaal 6 tekens bevatten",
  },
  dashboard: {
    title: "Projectaanvragen",
    subtitle: "Gekwalificeerde projectaanvragen voor uw bedrijf",
    tabNew: "Nieuw",
    tabInReview: "In behandeling",
    tabCompleted: "Afgerond",
    tabPayment: "Betaling & Facturering",
    tabProfile: "Profiel",
    noNew: "Geen nieuwe projectaanvragen",
    noInReview: "Geen lopende projectaanvragen",
    noCompleted: "Geen afgeronde projectaanvragen",
    selectForDetails: "Selecteer een projectaanvraag\nvoor details",
    weeklyLimitReached: "Weeklimiet bereikt",
    paymentMissing: "Betaalmethode ontbreekt",
    paymentMissingDesc: "Projectaanvragen worden pas geactiveerd na instelling van betaling.",
    setupPayment: "Nu instellen \u2192",
    paymentRequired: "Stel eerst een betaalmethode in",
    subscriptionBlocked: "Abonnement geblokkeerd \u2013 voltooi de betaling onder facturering",
    quotaExhausted: "Quotum bereikt \u2013 koop een add-on of upgrade uw plan",
    acceptError: "Fout bij accepteren",
    accepted: "Projectaanvraag geaccepteerd",
    declined: "Projectaanvraag afgewezen",
    declineError: "Fout bij afwijzen",
    questionSent: "Vervolgvraag verstuurd",
    completed: "Projectaanvraag afgerond",
    completeError: "Fout bij afronden",
  },
  onboarding: {
    progressCompany: "Bedrijf",
    progressTradesRegion: "Vakgebieden & Regio",
    progressConfig: "Configuratie",
    companyTitle: "Uw bedrijf",
    companySubtitle: "Basisinformatie voor uw profiel",
    companyName: "Bedrijfsnaam",
    companyNamePlaceholder: "Uw ambachtsbedrijf",
    contactPerson: "Contactpersoon",
    contactPersonPlaceholder: "Jan Jansen",
    masterCraftsman: "Meesterbedrijf",
    masterCraftsmanDesc: "Uw bedrijf is een geregistreerd meesterbedrijf",
    tradesTitle: "Uw vakgebieden",
    tradesSubtitle: "Welke vakgebieden dekt u?",
    regionTitle: "Uw locatie",
    regionSubtitle: "Waar is uw bedrijf gevestigd?",
    regionLabel: "Regio / Postcode",
    regionPlaceholder: "bijv. Amsterdam, 1012",
    radiusTitle: "Werkgebied",
    radiusSubtitle: "Hoe ver reist u naar klanten?",
    limitTitle: "Projectaanvraag-limiet",
    limitSubtitle: "Hoeveel aanvragen wilt u per week ontvangen?",
    limitFocused: "Gefocust",
    limitStandard: "Standaard",
    limitIntensive: "Intensief",
    completeTitle: "Bedrijfsprofiel opslaan",
    summaryCompany: "Bedrijf",
    summaryTrades: "Vakgebieden",
    summaryMaster: "Meesterbedrijf",
    summaryRadius: "Werkgebied",
    summaryLimit: "Limiet",
    summaryPerWeek: "per week",
    saveProfile: "Bedrijfsprofiel opslaan",
    saving: "Opslaan...",
    profileCreated: "Bedrijfsprofiel aangemaakt",
    saveError: "Fout bij opslaan",
    veryNear: "Zeer dichtbij",
    nearCity: "Nabij stad",
    regional: "Regionaal",
    wide: "Groot gebied",
    superRegional: "Superregionaal",
  },
  inquiry: {
    seoTitle: "Projectaanvraag indienen \u2013 Gekwalificeerde ambachtsbedrijven vinden",
    seoDesc: "Dien een projectaanvraag in bij CRAFTFINDUS: Beschrijf uw project en wij vinden tot 5 gekwalificeerde ambachtsbedrijven uit uw regio.",
    tradeElektriker: "Elektricien",
    tradeSanitaer: "Loodgieter",
    tradeHeizung: "Verwarming",
    tradeDachdecker: "Dakdekker",
    tradeInnenausbau: "Interieurafwerking",
    tradeSchreiner: "Schrijnwerker",
    tradeBauunternehmen: "Bouwbedrijf",
    tradeFensterbauer: "Raaminstallateur",
    tradeGartenbau: "Tuinaanleg",
    tradePhotovoltaik: "Zonnepanelen",
    tradeKlimaanlagen: "Airconditioning",
    tradeMalerbetrieb: "Schilder",
    progressDetails: "Projectdetails",
    progressDescription: "Beschrijving",
    progressContact: "Contact",
    questionOf: "Vraag {{current}} van {{total}}",
    tradeTitle: "Welk vakgebied heeft u nodig?",
    tradeSubtitle: "Selecteer het juiste vakgebied",
    tradesLoading: "Vakgebieden laden...",
    projectTypeTitle: "Type project",
    projectTypeSubtitle: "Wat moet er gedaan worden?",
    repair: "Reparatie",
    repairDesc: "Bestaande schade herstellen",
    newBuild: "Nieuwbouw",
    newBuildDesc: "Nieuw gebouw of aanbouw",
    renovation: "Renovatie",
    renovationDesc: "Bestaand renoveren",
    installation: "Installatie",
    installationDesc: "Nieuw systeem of apparatuur installeren",
    objectTypeTitle: "Type object",
    objectTypeSubtitle: "Welk type gebouw?",
    efh: "Vrijstaand huis",
    mfh: "Meergezinswoning",
    commercial: "Commercieel / Kantoor",
    industrial: "Industrie",
    publicBuilding: "Openbaar gebouw",
    urgencyTitle: "Hoe dringend is uw project?",
    urgencySubtitle: "Tijdschema voor start",
    immediate: "Direct",
    immediateDesc: "Zo snel mogelijk",
    oneWeek: "1 week",
    oneWeekDesc: "Binnen de komende 7 dagen",
    oneMonth: "1 maand",
    oneMonthDesc: "Binnen de komende 30 dagen",
    flexible: "Flexibel",
    flexibleDesc: "Geen vast tijdschema",
    budgetTitle: "Geschat budget",
    budgetSubtitle: "Helpt bij matching",
    under2k: "Onder \u20AC2.000",
    budget2k10k: "\u20AC2.000 tot \u20AC10.000",
    budget10k50k: "\u20AC10.000 tot \u20AC50.000",
    over50k: "Meer dan \u20AC50.000",
    budgetUnclear: "Nog onduidelijk",
    descriptionTitle: "Beschrijf uw project",
    descriptionSubtitle: "Max. 5.000 tekens",
    descriptionPlaceholder: "Wat moet er gedaan worden? Zijn er bijzonderheden?",
    desiredStart: "Gewenste startdatum (optioneel)",
    locationTitle: "Waar bevindt het project zich?",
    locationSubtitle: "Postcode of plaats invoeren",
    contactTitle: "Uw contactgegevens",
    contactSubtitle: "Voor contact door gekwalificeerde ambachtsbedrijven",
    contactNameLabel: "Naam *",
    contactNamePlaceholder: "Uw naam",
    contactEmailLabel: "E-mail *",
    contactPhoneLabel: "Telefoon *",
    contactPhonePlaceholder: "+31 ...",
    toSummary: "Verder naar overzicht",
    commitTitle: "Overdracht aan tot 5 gekwalificeerde ambachtsbedrijven",
    commitDesc: "Uw aanvraag wordt direct doorgestuurd naar passende bedrijven in uw regio.",
    summaryTrade: "Vakgebied",
    summaryProjectType: "Projecttype",
    summaryUrgency: "Urgentie",
    summaryLocation: "Locatie",
    summaryBudget: "Budget",
    submitInquiry: "Projectaanvraag indienen",
    submitting: "Wordt verzonden...",
    submitSuccess: "Projectaanvraag succesvol ingediend",
    submitError: "Fout bij verzenden van aanvraag",
  },
  thankyou: {
    inquiryTitle: "Uw projectaanvraag is ontvangen",
    inquiryDesc: "Wij matchen uw project nu met ons netwerk van gekwalificeerde ambachtsbedrijven.",
    nextStepsTitle: "Wat er nu gebeurt",
    inquiryStep1: "Wij beoordelen uw aanvraag en vinden tot 5 passende ambachtsbedrijven.",
    inquiryStep2: "U ontvangt contactsuggesties per e-mail \u2013 meestal binnen 24 uur.",
    inquiryStep3: "U beslist vrij met welk bedrijf u in gesprek gaat.",
    urgentContact: "Bij dringende vragen kunt u ons bereiken op",
    registrationTitle: "Registratie ontvangen!",
    registrationDesc: "Bedankt voor uw interesse in CRAFTFINDUS. Wij hebben uw registratie ontvangen.",
    registrationStep1: "Ons team beoordeelt uw gegevens zorgvuldig.",
    registrationStep2: "Na succesvolle beoordeling ontvangt u uw inloggegevens per e-mail.",
    registrationStep3: "U kunt dan inloggen en direct gekwalificeerde projectaanvragen ontvangen.",
    reviewTime: "De beoordeling duurt meestal 1\u20132 werkdagen.",
    contactTitle: "Bedankt voor uw bericht",
    contactDesc: "Wij hebben uw aanvraag ontvangen en nemen zo snel mogelijk contact met u op.",
    contactResponse: "Wij reageren meestal binnen 24 uur op werkdagen. Bij dringende zaken kunt u ons ook telefonisch bereiken op",
    sendAnother: "Nog een bericht sturen",
  },
  contact: {
    seoTitle: "Contact \u2013 CRAFTFINDUS bereiken",
    seoDesc: "Neem contact op met CRAFTFINDUS: Vragen over projectaanvragen, registratie of partnerschap?",
    title: "Contact",
    desc: "Heeft u vragen over {{brand}} of wilt u ons direct bereiken? Wij kijken uit naar uw bericht.",
    phoneLabel: "Telefoon",
    emailLabel: "E-mail",
    nameLabel: "Naam *",
    namePlaceholder: "Uw naam",
    emailFieldLabel: "E-mail *",
    emailPlaceholder: "uw@email.nl",
    subjectLabel: "Onderwerp *",
    subjectPlaceholder: "Waar gaat het over?",
    messageLabel: "Bericht *",
    messagePlaceholder: "Uw bericht aan ons...",
    sendBtn: "Bericht versturen",
    sending: "Wordt verzonden...",
    sent: "Bericht verzonden!",
    sendFailed: "Verzenden mislukt. Probeer het later opnieuw.",
    nameRequired: "Voer uw naam in",
    emailRequired: "Voer een geldig e-mailadres in",
    subjectRequired: "Voer een onderwerp in",
    messageMin: "Bericht moet minimaal 10 tekens bevatten",
  },
  about: {
    seoTitle: "Over CRAFTFINDUS \u2013 Eerlijke & intelligente ambachtsmatching",
    seoDesc: "CRAFTFINDUS verbindt opdrachtgevers met gekwalificeerde ambachtsbedrijven in de DACH-regio.",
    heroLabel: "Over {{brand}}",
    heroTitle1: "De mensen achter",
    heroTitle2: "CRAFTFINDUS.",
    heroDesc: "{{brand}} ontstond uit een eenvoudige observatie: Opdrachtgevers vinden moeilijk het juiste ambachtsbedrijf. En goede vakmensen besteden te veel tijd aan acquisitie in plaats van aan wat ze het beste kunnen.",
    teamLabel: "Ons team",
    teamTitle: "De mensen achter",
    founderRole: "Oprichter",
    founderBio1: "Als ondernemer uit Solingen ken ik beide kanten: De frustratie van opdrachtgevers die niet weten tot welk bedrijf ze zich moeten wenden. En de uitdaging voor ambachtsbedrijven om continu aan gekwalificeerde aanvragen te komen.",
    founderBio2: "{{brand}} is mijn antwoord op dit probleem. Een platform dat niet op massadistributie inzet, maar op intelligent, eerlijk matching. Waar kwaliteit telt en niet de laagste prijs wint.",
    chrisRole: "Zakenpartner",
    chrisBio: "Chris brengt strategisch denken en ondernemervaring in het team. Als zakenpartner drijft hij de ontwikkeling van {{brand}} voort en zorgt ervoor dat onze visie werkelijkheid wordt.",
    veronikaRole: "Directieassistente & Backoffice",
    veronikaBio: "Veronika houdt achter de schermen alle draden bij elkaar. Als directieassistente en backoffice-verantwoordelijke zorgt ze ervoor dat processen soepel verlopen en het team zich kan concentreren op wat ertoe doet.",
    dukeRole: "Kantoorhond & Feel-Good-Manager",
    dukeBio: "Geen vergadering zonder Duke. Onze Bull Terrier zorgt voor een goede sfeer, herinnert ons eraan pauze te nemen en is een vast onderdeel van het team. Als u ons belt, hoort u hem misschien op de achtergrond.",
    valuesLabel: "Onze waarden",
    valuesTitle: "Waar wij voor staan",
    value1Title: "Kwaliteit boven kwantiteit",
    value1Desc: "Wij geloven in minder, maar betere verbindingen. Daarom beperken we elke aanvraag tot 3 tot 5 bedrijven. Geen massadistributie, geen prijzenoorlog.",
    value2Title: "Eerlijkheid voor beide partijen",
    value2Desc: "Gratis voor opdrachtgevers, transparante vaste prijzen voor ambachtsbedrijven. Geen verborgen kosten, geen commissies op opdrachten.",
    value3Title: "Eenvoud",
    value3Desc: "Ambacht is complex genoeg. Wij vertalen de behoefte in de juiste taal en maken de weg naar het juiste bedrijf zo eenvoudig mogelijk.",
    missionLabel: "Onze missie",
    missionTitle: "Ambachtsmatching, zoals het hoort",
    missionP1: "De ambachtsmarkt is gefragmenteerd. Duizenden bedrijven, talloze portalen, maar nauwelijks echte ori\u00EBntatie. Opdrachtgevers vergelijken appels met peren. Ambachtsbedrijven vechten om zichtbaarheid op overvolle platforms.",
    missionP2: "{{brand}} doet het anders: Wij selecteren voor elke aanvraag gericht 3 tot 5 passende bedrijven. Geen bieden, geen prijsdumping. In plaats daarvan transparante scores, eerlijke prijzen en echte verbindingen.",
    missionP3: "Ons doel: Het eerste aanspreekpunt in de DACH-regio voor opdrachtgevers die een ambachtsbedrijf zoeken. En de voorkeursbron voor vakmensen die voorspelbaar willen groeien.",
    ctaTitle: "Klaar om ons te leren kennen?",
    ctaDesc: "Of u nu een ambachtsbedrijf zoekt of als vakman gekwalificeerde projectaanvragen wilt ontvangen: Wij kijken uit naar u.",
    ctaInquiry: "Projectaanvraag indienen",
    ctaContact: "Contact opnemen",
  },
  pricing: {
    seoTitle: "Prijzen \u2013 Abonnementen voor ambachtsbedrijven",
    seoDesc: "Transparante maandplannen voor gekwalificeerde projectaanvragen. Basic vanaf \u20AC49, Pro vanaf \u20AC129, Premium vanaf \u20AC249.",
    heroLabel: "Prijzen",
    heroTitle1: "Meer opdrachten.",
    heroTitle2: "Minder stilstand.",
    heroDesc: "Kies het plan dat bij uw bedrijf past. Alle plannen bevatten gekwalificeerde, vooraf geverifieerde projectaanvragen \u2013 direct in uw dashboard.",
    leadsIncluded: "geaccepteerde leads inbegrepen",
    choosePlan: "Plan kiezen",
    mostPopular: "Populairste plan",
    addonsLabel: "Add-ons",
    addonsTitle: "Extra leads boeken",
    radiusLabel: "Radiusuitbreidingen",
    radiusTitle: "Werkgebied uitbreiden",
    radiusDesc: "Vergroot uw werkradius en ontvang projectaanvragen uit een groter gebied.",
    trustNoContract: "Geen contractverplichting",
    trustInstant: "Direct klaar",
    trustVerified: "Alleen geverifieerde aanvragen",
    landingLabel: "Prijzen voor ambachtsbedrijven",
    landingTitle: "Transparante abonnementsplannen",
    landingDesc: "Kies het plan dat bij uw bedrijf past – geen verborgen kosten, geen contractverplichting.",
    landingCta: "Alle plannen bekijken",
    faqLabel: "Veelgestelde vragen",
    faqTitle: "Vragen over prijzen",
    ctaTitle: "Klaar voor nieuwe opdrachten?",
    ctaDesc: "Registreer gratis, kies uw plan en ontvang passende projectaanvragen.",
    ctaBtn: "Nu registreren",
    faq1q: "Betaal ik alleen bij acceptatie?",
    faq1a: "Nee \u2013 met een abonnement betaalt u een vast maandbedrag dat een bepaald aantal geaccepteerde leads bevat. U weet precies wat u betaalt. Extra leads kunnen als add-on worden bijgeboekt.",
    faq2q: "Wat gebeurt er als ik mijn quotum opgebruik?",
    faq2a: "Wanneer uw inbegrepen leads op zijn, kunt u een add-on kopen (+10 of +25 leads). Zonder add-on worden geen verdere leads vrijgegeven.",
    faq3q: "Kan ik van plan wisselen?",
    faq3a: "Ja, u kunt altijd upgraden. Het nieuwe plan wordt direct actief. Bij een downgrade loopt de huidige periode door.",
    faq4q: "Is er een contractverplichting?",
    faq4a: "Nee. U kunt uw abonnement op elk moment aan het einde van de lopende periode opzeggen. Geen minimale looptijd.",
    faq5q: "Wat is bijzonder aan het 'Premium'-plan?",
    faq5a: "Premium-bedrijven ontvangen een Geverifieerd-badge, worden prioritair behandeld bij levering en hebben een persoonlijk contactpersoon.",
  },
  billing: {
    title: "Facturering & Plan",
    subtitle: "Beheer uw plan, quota's en betaalmethode",
    tabPlan: "Plan & Facturering",
    tabQuotas: "Quota's",
    tabPayment: "Betaalmethode",
    statusActive: "Actief",
    statusTrial: "Proefperiode",
    statusPastDue: "Betaling achterstallig",
    statusBlocked: "Geblokkeerd",
    statusCanceled: "Opgezegd",
    statusPending: "In behandeling",
    pastDueBanner: "Betaling mislukt. Werk uw betaalmethode bij.",
    blockedBanner: "Abonnement geblokkeerd. Voltooi de betaling om door te gaan.",
    updatePayment: "Betaalmethode bijwerken",
    cancelledNotice: "Uw abonnement eindigt op {{date}}.",
    cancelSub: "Abonnement opzeggen",
    cancelConfirm: "Wilt u uw abonnement echt opzeggen aan het einde van de periode?",
    cancelSuccess: "Abonnement wordt opgezegd aan het einde van de periode",
    noPlan: "Geen actief plan",
    noPlanDesc: "Kies een plan om gekwalificeerde projectaanvragen te ontvangen.",
    changePlan: "Plan wijzigen",
    selectPlan: "Plan kiezen",
    currentPlan: "Huidig",
    activePlan: "Actief plan",
    leadsIncl: "Leads incl.",
    addonsTitle: "Add-ons",
    buy: "Kopen",
    acceptedLeads: "Geaccepteerde leads",
    deliveries: "Leveringen",
    quotaReached: "Quotum bereikt \u2013 koop een add-on of upgrade uw plan",
    billingPeriod: "Factureringsperiode",
    periodResets: "Quota's worden automatisch gereset aan het begin van elke periode.",
  },
  registration: {
    seoTitle: "Ambachtsbedrijf registreren \u2013 Gekwalificeerde projectaanvragen ontvangen",
    seoDesc: "Registreer als ambachtsbedrijf bij CRAFTFINDUS: Binnen 15 minuten klaar.",
    title: "Registreren als ambachtsbedrijf",
    subtitle: "Vul het formulier in. Na beoordeling ontvangt u uw inloggegevens per e-mail.",
    requiredFields: "Verplichte velden: Bedrijfsnaam, contactpersoon, e-mail",
    fillRequired: "Vul bedrijfsnaam, contactpersoon en e-mail in.",
    submitting: "Wordt verzonden...",
    submitBtn: "Registratie indienen",
    submitError: "Fout bij indienen",
  },
  handwerker: {
    seoTitle: "Klanten winnen \u2013 Gekwalificeerde projectaanvragen zonder koudebellen",
    seoDesc: "Win klanten zonder koudebellen: CRAFTFINDUS levert voorgekwalificeerde projectaanvragen passend bij uw vak & regio.",
    heroLabel: "Voor ambachtsbedrijven & meesterbedrijven",
    heroTitle1: "Gekwalificeerde projectaanvragen.",
    heroTitle2: "Geen prijzenoorlog.",
    heroDesc: "{{brand}} levert voorgekwalificeerde projectaanvragen van klanten die nu een vakman nodig hebben. Precies afgestemd op uw vak, beperkt tot 3 tot 5 bedrijven per project.",
    registerFree: "Nu gratis registreren",
    badgeNoContract: "Geen contractverplichting",
    badgeReady: "Klaar in 15 min",
    badgeVerified: "Alleen geverifieerde aanvragen",
    badgePayOnAccept: "Betaling alleen bij geaccepteerd project",
    benefitsLabel: "Uw voordelen",
    benefitsTitle: "Waarom ambachtsbedrijven voor {{brand}} kiezen",
    benefit1Title: "Precies gematcht",
    benefit1Desc: "Ons algoritme matcht elke aanvraag met uw profiel: vak, regio, capaciteit. U ontvangt alleen projecten die echt bij u passen.",
    benefit2Title: "Max. 3 tot 5 bedrijven per project",
    benefit2Desc: "Geen massadistributie. Elke aanvraag gaat naar weinige, geselecteerde ambachtsbedrijven. Minder concurrentie, hogere slagingspercentages.",
    benefit3Title: "Transparante vaste prijzen",
    benefit3Desc: "U betaalt alleen per geaccepteerde aanvraag \u2013 een vaste, transparante prijs. Geen maandelijkse kosten, geen commissies.",
    benefit4Title: "Voorgekwalificeerde aanvragen",
    benefit4Desc: "Elke projectaanvraag wordt beoordeeld voordat deze aan u wordt doorgestuurd. Geen spam, geen fantasieaanvragen \u2013 alleen echte projecten.",
    benefit5Title: "Voorspelbare groei",
    benefit5Desc: "Bepaal flexibel hoeveel aanvragen u per maand accepteert \u2013 en stuur uw bezetting.",
    benefit6Title: "Snelle toegang",
    benefit6Desc: "Registreren, profiel aanmaken, eerste aanvragen ontvangen. Binnen 15 minuten klaar.",
    pricingLabel: "Prijsvoorbeelden",
    pricingTitle: "Transparante vaste prijzen per projectaanvraag",
    pricingDesc: "U betaalt alleen voor aanvragen die u actief accepteert. De prijs hangt af van projectcategorie en -grootte.",
    smallProjects: "Kleine projecten",
    smallExamples: "bijv. stopcontacten plaatsen, kraan repareren, muur schilderen, slot vervangen",
    mediumProjects: "Middelgrote & grote projecten",
    mediumExamples: "bijv. badkamerrenovatie, verwarmingsvervanging, zonnepanelen, dakrenovatie, complete renovatie",
    priceFrom: "vanaf \u20AC{{price}}",
    perAcceptedInquiry: "per geaccepteerde projectaanvraag",
    goodToKnow: "Goed om te weten",
    goodToKnow1: "Geen maandelijkse kosten. U betaalt alleen bij acceptatie",
    goodToKnow2: "Projectgrootte bepaalt de prijs \u2013 vooraf transparant zichtbaar",
    goodToKnow3: "Klacht bij verkeerde kwalificatie \u2013 terugbetaling gegarandeerd",
    goodToKnow4: "Facturering via uw opgeslagen betaalmethode",
    howLabel: "Hoe het werkt",
    howTitle: "3 stappen naar nieuwe projecten",
    step1Title: "Profiel aanmaken",
    step1Desc: "Vak, regio, capaciteit en specialisatie opgeven.",
    step2Title: "Projectaanvragen ontvangen",
    step2Desc: "Passende projecten worden automatisch aan u geleverd.",
    step3Title: "Accepteren & contact opnemen",
    step3Desc: "U beslist welke projecten u accepteert en spreekt direct met de klant.",
    startNow: "Nu beginnen",
    faqLabel: "Veelgestelde vragen",
    faqTitle: "Vragen van ambachtsbedrijven",
    ctaTitle: "Klaar voor gekwalificeerde projectaanvragen?",
    ctaDesc: "Registreer gratis, maak uw profiel aan en ontvang passende projecten \u2013 zonder contractverplichting.",
    ctaBtn: "Gratis registreren",
  },
  notFound: {
    title: "Pagina niet gevonden",
    description: "De gevraagde pagina bestaat niet.",
  },
  limitReached: {
    title: "Pauze",
    subtitle: "Uw weeklimiet is bereikt.",
    nextReset: "Volgende ontgrendeling",
    description: "De limiet beschermt de kwaliteit van het platform en zorgt ervoor dat elke aanvraag de volledige aandacht krijgt.",
    adjustLimit: "Limiet aanpassen",
  },
  skipLink: "Ga naar hoofdinhoud",
  portal: {
    switchPortal: "Portaal wisselen",
    profile: "Profiel",
    changePassword: "Wachtwoord wijzigen",
    signOut: "Afmelden",
    newPassword: "Nieuw wachtwoord",
    passwordPlaceholder: "Minimaal 6 tekens",
    saving: "Wordt opgeslagen...",
    saveBtn: "Opslaan",
    cancelBtn: "Annuleren",
  },
  opportunityDetail: {
    company: "Bedrijf", confidentialUntilAccept: "Vertrouwelijk tot acceptatie", notSpecified: "Niet opgegeven",
    urgency: "Urgentie", decision: "Beslissing", matchScore: "Match-score", location: "Locatie",
    remote: "Remote", remotePossible: "Mogelijk", onsite: "Ter plaatse", compliance: "Compliance",
    complianceRelevant: "Relevant", onsiteLabel: "Ter plaatse", onsiteRequired: "Vereist",
    context: "Context", whySelected: "Waarom u geselecteerd bent", inquiryAccess: "Aanvraagtoegang",
    accepting: "Wordt geaccepteerd...", acceptInquiry: "Aanvraag accepteren", decline: "Afwijzen",
    responseWindow: "Reactievenster: 2u aanbevolen", claimLabel: "Claim", claimBtn: "Claimen",
    completed: "Afgerond", won: "Gewonnen", lost: "Verloren", noFit: "Geen match",
    claimApproved: "Goedgekeurd", claimRejected: "Afgewezen", claimUnderReview: "In beoordeling",
    claimSubmitted: "Ingediend", submittedAt: "Ingediend op", decidedAt: "Beslist op",
    reason: "Reden", rejectionReason: "Reden van afwijzing", note: "Opmerking",
    expiresIn: "Verloopt over {{hours}}u", expired: "Verlopen",
  },
  regForm: {
    companyData: "Bedrijfsgegevens", companyName: "Bedrijfsnaam *", companyNamePlaceholder: "Uw bedrijf",
    companyType: "Bedrijfstype", companyTypePlaceholder: "– Selecteer –", legalName: "Juridische naam",
    legalNamePlaceholder: "bijv. KvK-naam", contactPerson: "Contactpersoon *", contactPersonPlaceholder: "Uw naam",
    role: "Rol / Functie", rolePlaceholder: "bijv. Directeur", email: "E-mail *", emailPlaceholder: "uw@email.nl",
    phone: "Telefoon", phonePlaceholder: "+31 ...", website: "Website", websitePlaceholder: "https://...",
    invoiceEmail: "Factuur e-mail", invoiceEmailPlaceholder: "administratie@bedrijf.nl",
    address: "Adres", street: "Straat & nummer", postalCode: "Postcode", city: "Stad", country: "Land",
    countryDE: "Duitsland", countryAT: "Oostenrijk", countryCH: "Zwitserland",
    vatId: "BTW-nummer", vatIdPlaceholder: "NL123456789B01",
    contacts: "Contactpersonen", contactsDesc: "Optioneel: Extra contactpersonen",
    addContact: "Contact toevoegen", noContacts: "Nog geen extra contactpersonen",
    createContact: "Contact aanmaken", contactN: "Contact {{n}}", primaryContact: "Hoofdcontact",
    setPrimary: "Als hoofdcontact", nameRequired: "Naam *", emailRequired: "E-mail *", rolePlaceholderShort: "bijv. Verkoop",
  },
  stackPicker: { noResults: "Geen technologie gevonden", addCustom: "Eigen technologie toevoegen", customPlaceholder: "bijv. SAP, DATEV..." },
  thankyouExtra: { orVia: "of per", emailLabel: "E-mail" },
  pdExtra: { slaResponseTime: "SLA Reactietijd" },
  completionDialog: {
    confirmTitle: "Aanvraag afronden",
    confirmDesc: "Is de aanvraag afgerond en het contact met de klant be\u00EBindigd?",
    confirmYes: "Ja, afronden",
    confirmNo: "Nee, terug",
    outcomeTitle: "Resultaat",
    outcomeDesc: "Is er een opdracht tot stand gekomen?",
    won: "Ja \u2013 Opdracht gewonnen",
    lost: "Nee \u2013 Opdracht verloren",
    noFit: "Geen fit / Niet vervolgd",
  },
  suche: {
    seoTitle: "Ambachtelijk bedrijf vinden \u2013 gratis & zonder registratie",
    seoDesc: "Vind een passend ambachtelijk bedrijf: gratis, vrijblijvend & AVG-conform.",
    trustDach: "\uD83C\uDDE9\uD83C\uDDEA \uD83C\uDDE6\uD83C\uDDF9 \uD83C\uDDE8\uD83C\uDDED DACH-breed",
    trustFree: "100% gratis",
    trustGdpr: "AVG-conform",
    trustConsent: "Geen doorgifte zonder toestemming",
    heroTitle: "Vind het juiste ambachtelijke bedrijf.",
    heroAccent: "Gratis, vrijblijvend & zonder registratie",
    heroDesc: "Wij vinden passende ambachtelijke bedrijven uit uw regio via intelligent matching.",
    heroCta: "Nu ambachtelijk bedrijf vinden",
    heroSubline: "Gratis \u00B7 Vrijblijvend \u00B7 Reactie binnen 24u",
    howBtn: "Hoe werkt {{brand}}?",
    howTitle: "Hoe werkt {{brand}}?",
    howIntro: "{{brand}} verbindt opdrachtgevers met gekwalificeerde ambachtelijke bedrijven in de DACH-regio.",
    howStep1: "U beschrijft uw project",
    howStep1Desc: "in enkele stappen, geen vakkennis nodig.",
    howStep2: "Intelligent matching",
    howStep2Desc: "ons algoritme vindt passende bedrijven uit uw regio.",
    howStep3: "Menselijke validatie",
    howStep3Desc: "elke match wordt gecontroleerd voordat deze wordt verzonden.",
    howStep4: "Tot 5 bedrijven nemen contact op",
    howStep4Desc: "persoonlijk en rechtstreeks.",
    howFreeTitle: "Volledig gratis voor u",
    howFreeDesc: "De kosten worden gedragen door het ambachtelijke bedrijf.",
    problemsTitle: "U kent het",
    problemsAccent: "probleem",
    problemsSuffix: ". Wij vinden de oplossing",
    problemsDesc: "Geen vakkennis nodig. Beschrijf gewoon wat er gedaan moet worden.",
    problem1: "Verwarming kapot of loodgieterswerk nodig",
    problem2: "Elektra-installatie of zonnepanelen gepland",
    problem3: "Dak repareren of opnieuw bedekken",
    problem4: "Binnenwerk, droogbouw of schilderwerk",
    problem5: "Ramen, deuren of gevel vernieuwen",
    problem6: "Tuin- of landschapswerk",
    problemsCta: "Beschrijf nu uw project",
    problemsCtaSub: "Geen vakkennis vereist \u00B7 Begeleid proces",
    stepsTitle: "In 3 stappen naar de",
    stepsAccent: "juiste vakman",
    stepsDesc: "Zo eenvoudig werkt {{brand}} voor u",
    step1Title: "Project beschrijven",
    step1Desc: "Beschrijf in enkele stappen welke dienst u nodig heeft.",
    step2Title: "Wij matchen voor u",
    step2Desc: "Ons algoritme vindt passende bedrijven uit uw regio.",
    step3Title: "Offertes ontvangen",
    step3Desc: "Binnen 24 uur nemen tot 5 gekwalificeerde bedrijven contact met u op.",
    stepsBanner: "Volledig gratis \u00B7 Geen verborgen kosten \u00B7 Geen commissie",
    exampleTitle: "Zo ziet een",
    exampleAccent: "projectaanvraag",
    exampleSuffix: " eruit",
    exampleLabel: "Voorbeeld projectaanvraag",
    exampleName: "Badkamer renovatie compleet",
    exampleRegion: "Solingen",
    exampleObject: "Eengezinswoning",
    exampleUrgency: "Binnen 1 maand",
    exampleMatched: "4 passende bedrijven gevonden",
    regionLabel: "Regio",
    objectLabel: "Object",
    timeframeLabel: "Tijdskader",
    resultLabel: "Resultaat",
    exampleResult: "Binnen <strong>24 uur</strong> ontving deze opdrachtgever 4 passende offertes.",
    exampleCta: "Dien uw eigen projectaanvraag in",
    whyTitle: "Waarom opdrachtgevers {{brand}} gebruiken",
    why1: "Volledig gratis, geen verborgen kosten of commissies",
    why2: "AVG-conforme gegevensverwerking in Duitsland",
    why3: "Uw gegevens worden pas na toestemming gedeeld (max. 5)",
    why4: "Zorgvuldig geselecteerde bedrijven, max. 5 per aanvraag",
    why5: "Reactie binnen 24 uur",
    why6: "Persoonlijke ondersteuning bij vragen",
    whyTrust: "Vertrouwd door opdrachtgevers in de DACH-regio",
    ctaTitle: "Klaar om het juiste",
    ctaAccent: "ambachtelijke bedrijf",
    ctaSuffix: " te vinden?",
    ctaDesc: "Beschrijf uw project. Wij regelen de rest.",
    ctaBtn: "Nu ambachtelijk bedrijf vinden",
    ctaSubline: "Gratis \u00B7 Vrijblijvend \u00B7 Reactie binnen 24u",
    ctaPhone: "Vragen? Bel ons op",
    ctaForCraft: "Voor ambachtelijke bedrijven \u2192",
    ctaForLeads: "Projectaanvragen voor bedrijven \u2192",
    ctaContact: "Contact \u2192",
  },
  leads: {
    seoTitle: "Projectaanvragen ontvangen \u2013 Gekwalificeerde opdrachten",
    seoDesc: "Voorgekwalificeerde projectaanvragen uit DACH.",
    trustDach: "\uD83C\uDDE9\uD83C\uDDEA \uD83C\uDDE6\uD83C\uDDF9 \uD83C\uDDE8\uD83C\uDDED DACH-breed",
    trustGdpr: "AVG-conform",
    trustMax5: "Max. 5 bedrijven per aanvraag",
    trustPayOnAccept: "Betaling pas na acceptatie",
    trustNoSubs: "Geen abonnementen",
    trustCancelAnytime: "Altijd opzegbaar",
    heroTitle: "Gekwalificeerde projectaanvragen uit uw regio.",
    heroAccent: "U betaalt alleen als u accepteert",
    heroDesc: "Geen koude acquisitie. Geen abonnementen.\nAlleen echte projectaanvragen uit DACH.",
    heroCta: "Start nu gratis registratie",
    heroSubline: "Geen kosten \u00B7 Geen verplichting \u00B7 Betaling pas na acceptatie",
    benefitsTitle: "Uw voordelen als",
    benefitsAccent: "ambachtelijk bedrijf",
    benefit1Title: "Echte projectaanvragen",
    benefit1Desc: "Voorgekwalificeerde aanvragen met echte vraag.",
    benefit2Title: "Volledige controle",
    benefit2Desc: "U beslist welke aanvragen u accepteert.",
    benefit3Title: "Betaling na acceptatie",
    benefit3Desc: "Kosten ontstaan pas wanneer u een aanvraag actief accepteert.",
    benefitsCta: "Start nu gratis registratie",
    howTitle1: "Eenvoudig. Transparant.",
    howAccent: "Eerlijk.",
    howDesc: "Zo werkt {{brand}}: in drie stappen",
    howStep1: "Projectaanvraag vastleggen",
    howStep1Desc: "Een klant beschrijft zijn project.",
    howStep2: "Intelligent matching",
    howStep2Desc: "Ons algoritme selecteert alleen bedrijven die echt passen.",
    howStep3: "U beslist",
    howStep3Desc: "U ziet de aanvraag vooraf en betaalt alleen bij acceptatie.",
    howBanner: "Geen abo \u00B7 Geen minimumafname \u00B7 Geen verplichting",
    faqQ1: "Wat betekent \u2018gekwalificeerde projectaanvraag\u2019?",
    faqA1: "Een aanvraag met echte projectbehoefte.",
    faqQ2: "Wanneer ontstaan kosten?",
    faqA2: "Pas wanneer u een aanvraag actief accepteert.",
    faqQ3: "Kan ik aanvragen afwijzen?",
    faqA3: "Ja, altijd en zonder kosten.",
    trustTitle: "Waarom ambachtelijke bedrijven",
    trustAccent: "{{brand}} kiezen",
    trust1: "Geen vooruitbetaling",
    trust2: "Transparante projectinfo voor uw beslissing",
    trust3: "Regio & vakgebieden individueel instelbaar",
    trust4: "Eerlijk verdeeld, geen lead-overload",
    trust5: "Vervanging bij foutieve kwalificatie, gegarandeerd",
    trustCta: "Start nu gratis registratie",
    exampleTitle: "Zo ziet een",
    exampleAccent: "projectaanvraag",
    exampleSuffix: " eruit",
    exampleLabel: "Nieuwe projectaanvraag",
    exampleName: "Badkamer renovatie eengezinswoning",
    exampleMax5: "Deze aanvraag is naar max. <strong>5 bedrijven</strong> verzonden.",
    exampleCta: "Zulke aanvragen ontvangen",
    regionLabel: "Regio",
    tradeLabel: "Vakgebied",
    budgetLabel: "Budget",
    urgencyLabel: "Urgentie",
    objectLabel: "Object",
    securityTitle: "Vertrouwen is de",
    securityAccent: "basis",
    security1: "AVG-conforme gegevensverwerking in Duitsland",
    security2: "Geen doorgifte van contactgegevens zonder uw toestemming",
    security3: "Persoonlijke ondersteuning & eerlijke regels",
    security4: "Transparante prijzen per aanvraag",
    securityTrust: "Vertrouwd door pilotklanten in de DACH-regio",
    ctaTitle: "Klaar voor echte",
    ctaAccent: "projectaanvragen?",
    ctaDesc: "Registreer nu en beslis zelf welke aanvragen u wilt accepteren.",
    ctaBtn: "Start nu gratis registratie",
    ctaSubline: "Geen kosten \u00B7 Geen verplichting \u00B7 Altijd opzegbaar",
    ctaForCraft: "Voordelen voor ambachtelijke bedrijven \u2192",
    ctaForSearch: "Voor projectzoekers \u2192",
    ctaAbout: "Over CRAFTFINDUS \u2192",
  },
  feedback: {
    seoThankYou: "Feedback \u2013 Bedankt",
    thankYouTitle: "Bedankt!",
    thankYouDesc: "Uw feedback is succesvol ingediend.",
    errorTitle: "Fout",
    invalidLink: "Ongeldige of verlopen link.",
    formTitle: "Uw Feedback",
    formDesc: "Beoordeel uw ervaring met <strong>{{provider}}</strong>",
    submitBtn: "Feedback verzenden",
    submitting: "Wordt verzonden\u2026",
    anonymous: "Uw feedback is anoniem voor de dienstverlener.",
    answerPlaceholder: "Uw antwoord\u2026",
  },
  withdraw: {
    seoTitle: "Aanvraag intrekken",
    seoDesc: "Trek uw projectaanvraag bij CRAFTFINDUS in.",
    loading: "Link wordt gecontroleerd\u2026",
    errorTitle: "Ongeldige link",
    noToken: "Geen token opgegeven.",
    alreadyTitle: "Reeds ingetrokken",
    alreadyDesc: "Deze aanvraag is al geannuleerd.",
    title: "Aanvraag intrekken",
    confirmQuestion: "Wilt u de volgende aanvraag echt intrekken?",
    requestNumber: "Aanvraag-nr.",
    category: "Categorie",
    company: "Bedrijf",
    createdAt: "Aangemaakt op",
    reasonLabel: "Reden",
    reasonPlaceholder: "Waarom wilt u de aanvraag intrekken?",
    reasonMin: "Minimaal 5 tekens vereist",
    warning: "Door in te trekken worden alle toegewezen bedrijven ge\u00EFnformeerd en wordt de aanvraag geannuleerd. Dit kan niet ongedaan worden gemaakt.",
    submitBtn: "Aanvraag definitief intrekken",
    submitting: "Aanvraag wordt ingetrokken\u2026",
    successTitle: "Aanvraag ingetrokken",
    successDesc: "Uw aanvraag is succesvol geannuleerd.",
    notifiedOne: "{{count}} toegewezen bedrijf is ge\u00EFnformeerd.",
    notifiedMany: "{{count}} toegewezen bedrijven zijn ge\u00EFnformeerd.",
  },
  profileEdit: {
    title: "Profiel bewerken",
    subtitle: "Bedrijfsgegevens, adres, contact, vakgebieden en limieten",
    companySection: "Bedrijf",
    companyName: "Bedrijfsnaam *",
    companyType: "Bedrijfstype",
    companyTypePlaceholder: "\u2013 Selecteer \u2013",
    legalName: "Juridische naam",
    legalNamePlaceholder: "bijv. Voorbeeld BV",
    vatId: "BTW-nr.",
    vatIdPlaceholder: "NL123456789B01",
    website: "Website",
    addressSection: "Adres",
    street: "Straat & huisnummer",
    postalCode: "Postcode",
    city: "Stad",
    country: "Land",
    contactSection: "Hoofdcontact",
    contactName: "Contactpersoon *",
    contactRole: "Rol",
    contactRolePlaceholder: "bijv. Directeur",
    contactEmail: "E-mail",
    contactPhone: "Telefoon",
    contactPhonePlaceholder: "+31 ...",
    additionalContacts: "Extra contactpersonen",
    additionalContactsDesc: "Extra contactpersonen in uw bedrijf",
    addContact: "Toevoegen",
    createContact: "Contact aanmaken",
    noContacts: "Nog geen extra contactpersonen",
    contactLabel: "Contact {{n}}",
    primaryContact: "Hoofdcontact",
    nameRequired: "Naam *",
    emailRequired: "E-mail *",
    tradesSection: "Vakgebieden & diensten",
    tradesLabel: "Vakgebieden",
    stackLabel: "Technologie-stack",
    stackLoading: "Tags laden...",
    limitsSection: "Maandlimiet",
    monthlyLimit: "Maandelijks limiet",
    monthlyLimitDesc: "Maximaal aantal projectaanvragen per maand dat u wilt ontvangen.",
    monthlyLimitUnit: "Projectaanvragen / maand",
    noProfile: "Geen profiel gevonden.",
    createProfile: "Profiel aanmaken",
    saved: "Profiel opgeslagen",
    saveError: "Fout bij opslaan",
    notLoggedIn: "Niet ingelogd",
    saving: "Opslaan...",
    saveBtn: "Profiel opslaan",
  },
  sucheHeader: {
    cta: "Ambachtsbedrijf vinden",
    logoAlt: "CRAFTFINDUS | Ambachtsbedrijf vinden",
  },
  leadsHeader: {
    cta: "Projectaanvragen ontvangen",
    ctaTooltip: "U beslist welke aanvragen u accepteert",
    logoAlt: "CRAFTFINDUS | Gekwalificeerde projectaanvragen",
  },
  leadsFooter: {
    imprint: "Colofon",
    privacy: "Privacy",
    contact: "Contact",
    faq: "FAQ",
    forCraft: "Voor ambachtsbedrijven",
    motto: "Vinden \u00B7 Verbinden \u00B7 Oplossen",
  },
  op: {
    loadingPortal: "Operator portaal laden...",
    portalLabel: "CRAFTFINDUS Operator",
    roleLabel: "Operator",
    ctaNewProvider: "Nieuw bedrijf toevoegen",
    ctaNewProviderDesc: "Ambachtsbedrijf toevoegen",
    navDashboard: "Dashboard",
    navRegistrations: "Registraties",
    navRequests: "Projectaanvragen",
    navProviders: "Ambachtsbedrijven",
    navOpportunities: "Project Matching",
    navClaims: "Claims",
    navBilling: "Facturering",
    navCosts: "Kostenoverzicht",
    navPricing: "Prijzen",
    navMatching: "Matching",
    navSettings: "Instellingen",
    navAudit: "Audit Log",
    navSales: "Sales Dashboard",
    navROI: "ROI-Calculator",
    navFeedback: "Feedback",
    dashTitle: "Dashboard",
    dashSubtitle: "Overzicht van alle activiteiten",
    realtimeActive: "Realtime actief – Nieuwe aanvragen worden automatisch gematcht",
    realtimeConnecting: "Verbinding maken…",
    kpiNew7d: "Nieuwe projecten (7d)",
    kpiDelivered7d: "Afgeleverd (7d)",
    kpiFailed: "Mislukt",
    kpiClaimsOpen: "Claims open",
    kpiBlocked: "Bedrijven geblokkeerd",
    kpiRevenue: "Omzet (maand)",
    liveMatching: "Live Matching",
    waitingForRequests: "Wachten op nieuwe aanvragen…",
    recentRequests: "Recente projectaanvragen",
    noRequests: "Geen aanvragen beschikbaar",
    openClaims: "Open Claims",
    noOpenClaims: "Geen open claims",
    provTitle: "Bedrijven",
    provSubtitle: "Ambachtsbedrijven beheren",
    filterAll: "Alle",
    filterActive: "Actief",
    filterPending: "In behandeling",
    filterSuspended: "Geblokkeerd",
    filterPastDue: "Achterstallig",
    createProvider: "+ Bedrijf toevoegen",
    colProvider: "Bedrijf",
    colContact: "Contact",
    colRegion: "Regio",
    colStatus: "Status",
    colBilling: "Facturering",
    colSEPA: "SEPA",
    colMandate: "Mandaat",
    colLimit: "Limiet",
    colCreated: "Aangemaakt",
    statusActive: "Actief",
    statusPending: "In behandeling",
    statusSuspended: "Geblokkeerd",
    noProviders: "Geen bedrijven gevonden",
    reqTitle: "Projectaanvragen",
    reqSubtitle: "Alle ontvangen projectaanvragen",
    reqDetailTitle: "Aanvraagdetails",
    backToList: "Terug naar lijst",
    filterUnmatched: "Niet gematcht",
    filterMatched: "Gematcht",
    colNumber: "Nr.",
    colCategory: "Categorie",
    colCompany: "Bedrijf",
    colUrgency: "Urgentie",
    colPrice: "Prijs",
    colDate: "Datum",
    matched: "Gematcht",
    open: "Open",
    catSupport: "Kleine reparatie",
    catManaged: "Onderhoudscontract",
    catProject: "Bouwproject",
    catSecurity: "Nooddienst",
    catCloud: "Renovatie",
    urgImmediate: "Direct",
    urgWithin48h: "48 uur",
    urgWithin7d: "7 dagen",
    urgPlanned: "Gepland",
    decSelf: "Zelf",
    decTeam: "Team",
    decRecommend: "Aanbeveling",
    labelCategory: "Categorie",
    labelUrgency: "Urgentie",
    labelRegion: "Regio",
    labelRemote: "Remote",
    labelOnsite: "Ter plaatse",
    labelCompliance: "Compliance",
    labelDecision: "Beslissing",
    labelBudget: "Budget",
    labelPrice: "Prijs",
    labelProjectSize: "Projectomvang",
    labelSystems: "Systemen",
    labelUsers: "Gebruikers",
    labelDescription: "Beschrijving",
    labelContext: "Context",
    labelStackTags: "Vak-tags",
    labelOpportunities: "Kansen",
    labelMatchRuns: "Match-Runs",
    labelRequester: "Aanvrager",
    labelRiskFlags: "Risico-vlaggen",
    selected: "geselecteerd",
    startMatching: "Matching starten",
    matchingRunning: "Matching loopt...",
    matchingStarted: "Matching gestart",
    matchingFailed: "Matching mislukt",
    deleteRequest: "Aanvraag verwijderen",
    deleteRequestTitle: "Aanvraag verwijderen?",
    deleteRequestDesc: "De aanvraag <strong>{{number}}</strong> en alle gerelateerde gegevens worden permanent verwijderd.",
    cancelAction: "Annuleren",
    deleting: "Wordt verwijderd...",
    deleteForever: "Permanent verwijderen",
    requestDeleted: "Aanvraag {{number}} verwijderd",
    deleteError: "Fout bij verwijderen",
    loadError: "Fout bij laden van aanvragen",
    requestNotFound: "Aanvraag niet gevonden",
    regTitle: "Registraties",
    regSubtitle: "Registraties van ambachtsbedrijven controleren & beheren",
    regFilterPending: "In behandeling",
    regFilterApproved: "Goedgekeurd",
    regFilterRejected: "Afgewezen",
    regNew: "Nieuw",
    regNoEntries: "Geen registraties in deze categorie",
    regSelect: "Selecteer een registratie",
    regApproved: "Registratie goedgekeurd – Inloggegevens worden aangemaakt",
    regRejected: "Registratie afgewezen",
    regCreated: "Registratie aangemaakt",
    regUpdated: "Registratie bijgewerkt",
    regDeleted: "Registratie verwijderd",
    regDeleteTitle: "Registratie verwijderen?",
    regDeleteDesc: "De registratie van <strong>{{company}}</strong> wordt permanent verwijderd.",
    oppTitle: "Project Matching",
    oppSubtitle: "Alle gematchte projectaanvragen monitoren",
    filterNew: "Nieuw",
    filterInReview: "In beoordeling",
    filterFailed: "Mislukt",
    filterHold: "Hold",
    colScore: "Score",
    colDelivery: "Aflevering",
    selectOpp: "Selecteer een aanvraag",
    resend: "Opnieuw versturen",
    resendTriggered: "Opnieuw verstuurd",
    labelHoldReason: "Hold reden",
    labelRequestCompany: "Bedrijf (aanvraag)",
    labelRequestEmail: "E-mail (aanvraag)",
    labelLocation: "Locatie",
    claimTitle: "Claims",
    claimSubtitle: "Claims beoordelen en beslissen",
    claimFilterOpen: "Open",
    claimFilterDecided: "Beslist",
    claimNone: "Geen claims",
    claimSelectDetail: "Selecteer een claim voor details",
    claimDetailTitle: "Claim Detail",
    claimReason: "Reden",
    claimComment: "Opmerking",
    claimOppPrice: "Opportunity-prijs",
    claimSubmittedAt: "Ingediend op",
    claimOperatorNote: "Operator-notitie",
    claimCredit: "Creditering (cents)",
    claimApprove: "Goedkeuren",
    claimReject: "Afwijzen",
    claimApproved: "Claim goedgekeurd",
    claimRejected: "Claim afgewezen",
    billTitle: "Facturering Monitor",
    billSubtitle: "Facturering, mandaten en verzendstatus",
    billOverdue: "Achterstallig",
    billMandate: "Betaalmiddelen",
    billEmailFailures: "E-mail fouten",
    billMonthClose: "Maandafsluiting",
    billInvoices: "Facturen",
    billCloseMonth: "Maand afsluiten",
    billClosing: "Wordt afgesloten...",
    billMonthClosed: "Maand {{month}} afgesloten",
    noEntries: "Geen invoer",
    colOverdueSince: "Achterstallig sinds",
    colMethods: "Methoden",
    colOpportunity: "Opportunity",
    colError: "Fout",
    colAttempts: "Pogingen",
    colMonth: "Maand",
    colAmount: "Bedrag",
    colNet: "Netto",
    colGross: "Bruto",
    colPeriod: "Periode",
    costTitle: "Kostenoverzicht",
    costSubtitle: "Geaccepteerde projectaanvragen per bedrijf · Maandelijkse facturering",
    costProviders: "Bedrijven",
    costAccepted: "Geaccepteerde projectaanvragen",
    costTotal: "Totaalbedrag ({{month}})",
    costVatNote: "excl. BTW · Facturering aan einde van de maand",
    costNoAccepted: "Geen geaccepteerde projectaanvragen in {{month}}",
    colAccepted: "Geaccepteerd",
    colAmountNet: "Bedrag (netto)",
    colAmountGross: "Bedrag (bruto)",
    costTotalRow: "Totaal",
    costFooter: "Alle bedragen in EUR · BTW 19% · Facturering aan het einde van de kalendermaand",
    auditTitle: "Audit Log",
    auditSubtitle: "Globaal activiteitenlog",
    auditAllEntities: "Alle entiteiten",
    auditAllEvents: "Alle events",
    auditRetention: "Retentie",
    auditCSV: "CSV Export",
    auditRetentionLabel: "Invoer automatisch verwijderen na:",
    auditDays: "Dagen",
    auditSaved: "Retentie ingesteld op {{days}} dagen",
    auditPurgeConfirm: "Alle audit log-invoer ouder dan {{days}} dagen nu verwijderen?",
    auditPurged: "Oude invoer verwijderd",
    auditPurgeNow: "Nu opschonen",
    auditCurrentRetention: "Huidig opgeslagen: <span>{{days}} dagen</span>.",
    colTimestamp: "Tijdstempel",
    colEvent: "Event",
    colEntity: "Entiteit",
    colActor: "Actor",
    colMeta: "Meta",
    auditEntries: "{{count}} invoer · Pagina {{page}} van {{total}}",
    setTitle: "Instellingen",
    setSubtitle: "Platformconfiguratie",
    setProviderTemplates: "Bedrijf-templates",
    setCustomerTemplates: "Klant-templates",
    setGraph: "Microsoft Graph",
    setUsers: "Gebruikersbeheer",
    setApiKeys: "API-sleutels",
    setSaveTemplates: "Templates opslaan",
    setTemplatesSaved: "E-mailtemplates opgeslagen",
    setGraphTitle: "Microsoft Graph API",
    setGraphDesc: "Configuratie voor e-mailverzending via Graph API (Mail.Send)",
    setTenantId: "Tenant ID",
    setClientId: "Client ID",
    setClientSecret: "Client Secret",
    setSenderEmail: "Afzender e-mail",
    setRetryPolicy: "Retry-beleid",
    setMaxAttempts: "Max. pogingen",
    setIntervals: "Intervallen (min)",
    setIntervalsHint: "Kommagescheiden, bijv. 5,10,30",
    setSaveGraph: "Graph-instellingen opslaan",
    setSavingGraph: "Wordt opgeslagen...",
    setGraphSaved: "Microsoft Graph instellingen opgeslagen",
    setTestEmail: "Test-e-mail versturen",
    setTestTitle: "Test-e-mail versturen",
    setTestDesc: "Voer het ontvangstadres in voor een test-e-mail via Microsoft Graph.",
    setTestRecipient: "Ontvanger e-mail",
    setTestSending: "Wordt verzonden...",
    setTestSend: "Verzenden",
    setTestSent: "Test-e-mail verzonden naar {{email}}",
    profTitle: "Mijn Profiel",
    profSubtitle: "Persoonlijke instellingen en beveiliging",
    profAccess: "Operator-toegang",
    profDisplayName: "Weergavenaam",
    profDisplayNamePlaceholder: "Uw naam",
    profSaveName: "Naam opslaan",
    profNameSaved: "Naam opgeslagen",
    profChangePassword: "Wachtwoord wijzigen",
    profNewPassword: "Nieuw wachtwoord",
    profNewPasswordPlaceholder: "Minimaal 6 tekens",
    profConfirmPassword: "Wachtwoord bevestigen",
    profConfirmPasswordPlaceholder: "Wachtwoord herhalen",
    profPasswordChanged: "Wachtwoord succesvol gewijzigd",
    profPasswordMinLength: "Wachtwoord moet minimaal 6 tekens bevatten",
    profPasswordMismatch: "Wachtwoorden komen niet overeen",
    profAccountDetails: "Accountdetails",
    profEmail: "E-mail",
    profCreatedAt: "Account aangemaakt",
    profLastSignIn: "Laatst ingelogd",
    profSaving: "Wordt opgeslagen...",
    pricTitle: "Prijzen",
    pricSubtitle: "Abonnementen, add-ons & prijsconfiguratie",
    pricPlans: "Abonnementen",
    pricAddons: "Add-ons",
    pricPreview: "Preview prijzenpagina",
    pricNewPlan: "Nieuw plan",
    pricEditPlan: "Plan bewerken",
    pricPlanSaved: "Plan opgeslagen",
    pricPlanDeleted: "Plan verwijderd",
    pricDeleteConfirm: "Plan verwijderen?",
    pricNewAddon: "Nieuwe add-on",
    pricEditAddon: "Add-on bewerken",
    pricAddonSaved: "Add-on opgeslagen",
    pricAddonDeleted: "Add-on verwijderd",
    pricKey: "Sleutel",
    pricName: "Naam",
    pricPriceCents: "Prijs (centen)",
    pricInclLeads: "Incl. leads",
    pricMaxDeliveries: "Max. leveringen",
    pricMaxRadius: "Max. radius (km)",
    pricMaxTrades: "Max. vakgebieden",
    pricSort: "Sortering",
    pricFeaturesJSON: "Features (JSON Array)",
    pricActiveLabel: "Actief",
    pricInactive: "Inactief",
    pricEdit: "Bewerken",
    pricExtraLeads: "Extra leads",
    matchTitle: "Matching",
    matchSubtitle: "Matching-engine configuratie",
    matchWeights: "Gewichten",
    matchLimits: "Limieten & Eerlijkheid",
    matchAI: "AI Matching",
    matchScoreWeights: "Score-gewichten",
    matchScoreDesc: "Verdeling van 100 punten over matching-dimensies.",
    matchCurrent: "Huidig:",
    matchStackMatch: "Vakgebied-match",
    matchStackMatchDesc: "Overeenkomst tussen bedrijfsprofiel en projectaanvraag",
    matchUrgencyFit: "SLA / Urgentie",
    matchUrgencyFitDesc: "SLA-reactietijd vs. urgentie van de aanvraag",
    matchGeoFit: "Geografie",
    matchGeoFitDesc: "Locatie- en remote-compatibiliteit",
    matchReliability: "Betrouwbaarheid",
    matchReliabilityDesc: "Acceptatiegraad en reactietijd van het bedrijf",
    matchQuality: "Kwaliteit",
    matchQualityDesc: "Interne kwaliteitsscore van het bedrijf",
    matchLimitsTitle: "Limieten & Eerlijkheid",
    matchLimitsDesc: "Beheer bedrijfsselectie en eerlijkheidsregels",
    matchMaxProviders: "Max. bedrijven per aanvraag",
    matchMaxProvidersDesc: "Hoeveel bedrijven per aanvraag worden gematcht",
    matchMinScore: "Min. score-drempel",
    matchMinScoreDesc: "Bedrijven onder deze score worden uitgesloten",
    matchFairnessDelta: "Eerlijkheidsdelta",
    matchFairnessDeltaDesc: "Scoreverschil voor eerlijkheidsrotatie",
    matchExpiryHours: "Vervaltijd (uren)",
    matchExpiryDesc: "Aanvraag vervalt na deze tijd",
    matchOverage: "Overschrijdingstolerantie (%)",
    matchOverageDesc: "= Bedrijf mag zijn maandlimiet met {{percent}}% overschrijden",
    matchOverageExample: "Voorbeeld: Bij limiet 20 en 20% tolerantie kan het bedrijf tot 24 aanvragen accepteren",
    matchSaveConfig: "Configuratie opslaan",
    matchSaving: "Wordt opgeslagen...",
    matchSaved: "Matching-configuratie opgeslagen",
    matchWeightError: "Gewichten moeten 100 zijn (huidig: {{total}})",
    matchAITitle: "AI-Enhanced Matching",
    matchAIDesc: "AI-gestuurde analyse en beoordeling van aanvragen",
    matchAIModel: "AI-model",
    matchAIFunctions: "AI-functies",
    matchAIEnhanceReasons: "Match-redenen verbeteren",
    matchAIEnhanceReasonsDesc: "AI genereert gedetailleerde uitleg waarom een bedrijf past",
    matchAIAdjustScores: "Score-aanpassingen",
    matchAIAdjustScoresDesc: "AI kan scores aanpassen op basis van contextanalyse",
    matchAIMaxAdjustment: "Max. score-aanpassing (±)",
    matchAIMaxAdjustmentDesc: "Maximale punten die AI mag toevoegen/aftrekken",
    matchAIHowTitle: "Hoe AI-Matching werkt",
    fbTitle: "Feedback",
    fbSubtitle: "Klantfeedback beheren en versturen",
    fbRequests: "Aanvragen",
    fbConfig: "Configuratie",
    fbWonWithout: "Gewonnen aanvragen zonder feedback ({{count}})",
    fbSend: "Versturen",
    fbEmailSent: "Feedback-e-mail verzonden",
    fbAllRequests: "Alle feedbackaanvragen",
    fbNoRequests: "Nog geen feedbackaanvragen aangemaakt.",
    fbResend: "Opnieuw versturen",
    fbEmailResent: "E-mail opnieuw verzonden",
    fbResponses: "Antwoorden",
    fbNoResponses: "Geen antwoorden.",
    fbConfigDesc: "Configureer de vragen die klanten in het feedbackformulier zien.",
    fbEditQuestion: "Vraag bewerken",
    fbNewQuestion: "Nieuwe vraag aanmaken",
    fbQuestionText: "Vraagtekst",
    fbType: "Type",
    fbTypeRating: "Sterrenbeoordeling",
    fbTypeText: "Vrije tekst",
    fbTypeYesNo: "Ja/Nee",
    fbTypeScale: "Schaal (1-10)",
    fbSaved: "Opgeslagen",
    salesTitle: "Sales Dashboard",
    salesSubtitle: "KPI's & verkoopargumenten",
    salesTotalProviders: "Totaal bedrijven",
    salesActiveProviders: "Actieve bedrijven",
    salesNewRegs7d: "Nieuwe registraties (7d)",
    salesAvgAcceptance: "Gem. acceptatiegraad",
    salesOpps30d: "Kansen (30d)",
    salesDelivered30d: "Afgeleverd (30d)",
    salesRevenue: "Omzet (maand)",
    salesAvgScore: "Gem. Match-Score",
    salesElevatorPitch: "Elevator Pitch (30 sec.)",
    salesCopy: "Kopiëren",
    salesCopied: "Gekopieerd",
    salesTop5: "Top 5 verkoopargumenten",
    salesArgRiskFree: "Risicovrij",
    salesArgRiskFreeDesc: "Geen contracten, geen basiskosten, betaal alleen bij acceptatie",
    salesArgQuality: "Kwaliteit",
    salesArgQualityDesc: "Voorgekwalificeerde aanvragen, algoritme-gebaseerde matching",
    salesArgFairness: "Eerlijkheid",
    salesArgFairnessDesc: "Max. 3–5 concurrenten, geen prijzenoorlog",
    salesArgFast: "Snel",
    salesArgFastDesc: "In 15 minuten geregistreerd, eerste leads binnen uren",
    salesArgFlexible: "Flexibel",
    salesArgFlexibleDesc: "Wekelijkse limiet instelbaar, altijd pauzeerbaar",
    salesStrongestNumbers: "De 3 sterkste cijfers",
    salesAcceptanceRate: "Acceptatiegraad",
    salesResponseTime: "Gem. reactietijd",
    salesProvidersPerRequest: "Ambachtslieden per aanvraag",
    salesObjectionHandling: "Bezwaarbehandeling",
    salesBenchmarks: "Bedrijf-KPI benchmarks (voor argumentatie)",
    salesKPI: "KPI",
    salesBenchmark: "CRAFTFINDUS Benchmark",
    roiTitle: "ROI-Calculator",
    roiSubtitle: "Interactieve calculator voor verkoopgesprekken",
    roiParams: "Parameters aanpassen",
    roiLeadsPerMonth: "Leads per maand",
    roiAvgLeadPrice: "Gem. leadprijs (€)",
    roiConversion: "Conversiepercentage Lead → Klant (%)",
    roiAvgDealValue: "Gem. orderwaarde (€)",
    roiCurrentCAC: "Huidige acquisitiekosten per klant (€)",
    roiIndustryAvg: "Branchegemiddelde: 1.500–3.000 €",
    roiScenarios: "Snelscenario's",
    roiMonthlyCost: "Maandelijkse CRAFTFINDUS-kosten",
    roiExpectedCustomers: "Verwachte nieuwe klanten",
    roiExpectedRevenue: "Verwachte omzet",
    roiLabel: "ROI",
    roiCACComparison: "Acquisitiekosten-vergelijking",
    roiCurrentCACLabel: "Huidige CAC",
    roiCraftfindusCAC: "CRAFTFINDUS CAC",
    roiSavingsPerCustomer: "Besparing per klant",
    roiCurrent: "Huidig",
    roiWithCraftfindus: "Met CRAFTFINDUS",
    roiAnnualSavings: "Jaarlijkse besparing op acquisitiekosten",
    roiBasedOn: "Gebaseerd op {{count}} nieuwe klanten/jaar",
    roiTalkingPoint: "Gesprekshulp",
    pdTabProfile: "Profiel & Status",
    pdTabServices: "Services & Stack",
    pdMasterData: "Stamgegevens",
    pdContact: "Contact",
    pdPhone: "Telefoon",
    pdWebsite: "Website",
    pdCompanyType: "Bedrijfstype",
    pdRemote: "Remote",
    pdSLA: "SLA",
    pdMonthlyLimit: "Maandlimiet",
    pdAddress: "Adres",
    pdResendWelcome: "Welkomstmail opnieuw versturen",
    pdResetPassword: "Wachtwoord resetten",
    pdAdditionalContacts: "Extra contactpersonen",
    pdStatusActions: "Status & Acties",
    pdApproved: "Goedgekeurd",
    pdSuspended: "Geblokkeerd",
    pdSuspendReason: "Blokkeergreden:",
    pdSuspendedAt: "Geblokkeerd op:",
    pdFailedDebits: "Mislukte incasso's:",
    pdApprove: "Goedkeuren",
    pdSuspend: "Handmatig blokkeren",
    pdSuspendPrompt: "Reden voor blokkering:",
    pdUnsuspend: "Deblokkeren",
    pdDelete: "Verwijderen",
    pdDeleteTitle: "Ambachtsbedrijf verwijderen?",
    pdDeleteDesc: "<strong>{{company}}</strong> wordt permanent verwijderd.",
    pdDeleted: "Ambachtsbedrijf verwijderd",
    pdPayment: "Betaalmiddel (Mollie)",
    pdPaymentStatus: "Status",
    pdSetupStatus: "Setup-status",
    pdMollieCustomer: "Mollie-klant",
    pdPaymentMethods: "Methoden",
    pdActivateManual: "Handmatig activeren",
    pdDeactivateManual: "Handmatig deactiveren",
    pdPaymentUpdated: "Betaalstatus bijgewerkt",
    pdActionSuccess: "Actie {{action}} succesvol",
    pdCategories: "Categorieën",
    pdNoCategories: "Geen categorieën toegewezen",
    pdStack: "Stack / Vakgebieden",
    pdNoStack: "Geen stack-tags toegewezen",
    pdAuditLog: "Activiteitenlog",
    pdNoAuditLog: "Geen activiteiten",
    pcTitle: "Bedrijf toevoegen",
    pcSubtitle: "Nieuw ambachtsbedrijf onboarden",
    pcCreateBtn: "Bedrijf toevoegen",
    pcCreating: "Wordt aangemaakt...",
    pcCreated: "Ambachtsbedrijf aangemaakt",
    pcRequiredFields: "Verplichte velden invullen (Bedrijf, Contact, E-mail)",
    pcLoginRequired: "Login-e-mail opgeven voor portaaltoegang",
    pcCreateError: "Fout bij aanmaken",
    monthJan: "Januari",
    monthFeb: "Februari",
    monthMar: "Maart",
    monthApr: "April",
    monthMay: "Mei",
    monthJun: "Juni",
    monthJul: "Juli",
    monthAug: "Augustus",
    monthSep: "September",
    monthOct: "Oktober",
    monthNov: "November",
    monthDec: "December",
    regFilterAll: "Alle",
    regEmpty: "Geen registraties in deze categorie",
    regSelectHint: "Selecteer een registratie",
    regApproveSuccess: "Registratie goedgekeurd – Inloggegevens worden aangemaakt",
    regApproveError: "Fout bij goedkeuren",
    regRejectSuccess: "Registratie afgewezen",
    regRejectError: "Fout bij afwijzen",
    regCreateSuccess: "Registratie aangemaakt",
    regUpdateSuccess: "Registratie bijgewerkt",
    regDeleteSuccess: "Registratie verwijderd",
    regDeleteError: "Fout bij verwijderen",
    regDeleteConfirm: "Permanent verwijderen",
    oppFilterNew: "Nieuw",
    oppFilterInReview: "In beoordeling",
    oppFilterFailed: "Mislukt",
    oppFilterHold: "Hold",
    oppColNumber: "Nr.",
    oppColCategory: "Categorie",
    oppColProvider: "Bedrijf",
    oppColScore: "Score",
    oppColStatus: "Status",
    oppColDelivery: "Aflevering",
    oppColPrice: "Prijs",
    oppEmpty: "Geen aanvragen",
    oppSelectHint: "Selecteer een aanvraag",
    oppResend: "Opnieuw versturen",
    oppResendSuccess: "Opnieuw verstuurd",
    oppDetailUrgency: "Urgentie",
    oppDetailCompany: "Bedrijf (aanvraag)",
    oppDetailEmail: "E-mail (aanvraag)",
    oppDetailLocation: "Locatie",
    oppDetailHoldReason: "Hold reden",
    claimEmpty: "Geen claims",
    claimSelectHint: "Selecteer een claim voor details",
    claimDetail: "Claim Detail",
    claimCreditCents: "Creditering (centen)",
    claimApproveSuccess: "Claim goedgekeurd",
    claimRejectSuccess: "Claim afgewezen",
    billingTitle: "Facturering Monitor",
    billingSubtitle: "Facturering, mandaten en verzendstatus",
    billingOverdue: "Achterstallig",
    billingMandate: "Betaalmiddelen",
    billingEmailFailures: "E-mail fouten",
    billingMonthClose: "Maandafsluiting",
    billingInvoices: "Facturen",
    billingCloseMonth: "Maand afsluiten",
    billingCloseSuccess: "Maand {{month}} afgesloten",
    billingEmpty: "Geen invoer",
    billingOverdueSince: "Achterstallig sinds",
    billingMethods: "Methoden",
    billingError: "Fout",
    billingAttempts: "Pogingen",
    billingMonth: "Maand",
    billingAmount: "Bedrag",
    billingNet: "Netto",
    billingGross: "Bruto",
    billingPeriod: "Periode",
    colBillingStatus: "Factureringsstatus",
    profileTitle: "Mijn Profiel",
    profileSubtitle: "Persoonlijke instellingen en beveiliging",
    profileRole: "Operator-toegang",
    profileDisplayName: "Weergavenaam",
    profileNamePlaceholder: "Uw naam",
    profileSaveName: "Naam opslaan",
    profileNameSuccess: "Naam opgeslagen",
    profileNameError: "Fout bij opslaan naam",
    profileChangePassword: "Wachtwoord wijzigen",
    profileNewPassword: "Nieuw wachtwoord",
    profilePasswordPlaceholder: "Minimaal 6 tekens",
    profileConfirmPassword: "Wachtwoord bevestigen",
    profileConfirmPlaceholder: "Wachtwoord herhalen",
    profilePasswordSuccess: "Wachtwoord succesvol gewijzigd",
    profilePasswordError: "Fout bij wijzigen wachtwoord",
    profilePasswordMinLength: "Wachtwoord moet minimaal 6 tekens bevatten",
    profilePasswordMismatch: "Wachtwoorden komen niet overeen",
    profileAccountDetails: "Accountdetails",
    profileEmail: "E-mail",
    profileCreatedAt: "Account aangemaakt",
    profileLastLogin: "Laatst ingelogd",
    createTitle: "Bedrijf toevoegen",
    createSubtitle: "Nieuw ambachtsbedrijf onboarden",
    createSubmit: "Bedrijf toevoegen",
    createSuccess: "Ambachtsbedrijf aangemaakt",
    createError: "Fout bij aanmaken",
    createRequiredFields: "Verplichte velden invullen (Bedrijf, Contact, E-mail)",
    createLoginEmailRequired: "Login-e-mail opgeven voor portaaltoegang",
  },
  aiSearch: {
    title: "Wat is CRAFTFINDUS?",
    definition: "CRAFTFINDUS is een digitaal kwaliteitsplatform voor de bemiddeling van geverifieerde ambachtsbedrijven in Duitsland, Oostenrijk, Zwitserland, Nederland, België, Frankrijk en Polen. Opdrachtgevers beschrijven hun project – CRAFTFINDUS vindt via intelligent matching 3 tot 5 passende, geverifieerde vakmensen in de regio. De service is gratis en vrijblijvend voor opdrachtgevers. Ambachtsbedrijven betalen een transparante vaste prijs per geaccepteerd contact – zonder commissies, zonder contractverplichting.",
    highlight1: "Geverifieerde bedrijven: KvK-inschrijving, verzekering, kredietwaardigheid gecontroleerd",
    highlight2: "Max. 3–5 bedrijven per project: eerlijke kansen, geen prijzenoorlog",
    highlight3: "Transparante prijzen: vaste contactprijzen, geen verborgen kosten",
    highlight4: "Eerlijk klachtenproces: terugbetaling bij ongekwalificeerde contacten",
  },
  seoLanding: {
    verified: "Geverifieerde bedrijven",
    free: "Gratis & vrijblijvend",
    fast: "Antwoord binnen 24u",
    ctaRequest: "Nu aanvraag indienen",
    freeForClients: "Gratis voor opdrachtgevers",
    whatIsCraftfindus: "Wat is CRAFTFINDUS?",
    whatIsCraftfindusText: "CRAFTFINDUS is een digitaal platform dat opdrachtgevers verbindt met geverifieerde ambachtsbedrijven in Duitsland, Oostenrijk, Zwitserland, België, Nederland, Frankrijk en Polen. U beschrijft uw project – wij vinden 3 tot 5 passende bedrijven bij u in de buurt. Gratis en vrijblijvend.",
    verifiedProviders: "Geverifieerde {{trade}} in {{city}}",
    howItWorks: "Zo werkt CRAFTFINDUS",
    costs: "{{trade}} kosten & prijzen",
    inCity: "in {{city}}",
    faq: "Veelgestelde vragen",
    ctaHeading: "{{trade}} in {{city}} gezocht?",
    ctaSubtext: "Dien nu uw gratis aanvraag in en ontvang tot 5 offertes van geverifieerde bedrijven.",
    relatedCities: "{{trade}} in andere steden",
    otherTrades: "Andere vakgebieden in {{city}}",
    relatedArticles: "Gerelateerde gidsen",
  },
  blog: {
    title: "CRAFTFINDUS Gids",
    description: "Tips, kosten en gidsen voor ambachtsprojecten",
    noPosts: "Nog geen berichten.",
    backToList: "Terug naar gids",
  },
  warum: {
    seoTitle: "Waarom CRAFTFINDUS – Het kwaliteitsplatform voor ambachtsmatch",
    seoDesc: "Ontdek waarom CRAFTFINDUS anders is: leadkwaliteitscontrole, transparante prijzen, geverifieerde bedrijven en een eerlijk klachtproces.",
    heroLabel: "Waarom CRAFTFINDUS",
    heroTitle1: "Ambachtsmatch,",
    heroTitle2: "zoals het hoort.",
    heroDesc: "De meeste platforms verdelen contacten. Wij matchen gekwalificeerde projecten met geverifieerde bedrijven – eerlijk, transparant en resultaatgericht.",
    problemLabel: "Het marktprobleem",
    problemTitle: "Wat er misgaat bij andere platforms",
    problem1Title: "Ongekwalificeerde aanvragen",
    problem1Desc: "Contacten zonder budget, zonder echt project, zonder geverifieerde gegevens. U betaalt voor leads die nooit opdrachten worden.",
    problem2Title: "Ondoorzichtige kosten",
    problem2Desc: "Verborgen kosten, commissies op opdrachten, onduidelijke prijsmodellen.",
    problem3Title: "Massadistributie",
    problem3Desc: "Uw aanvraag gaat naar 10, 15 of 20 bedrijven tegelijk. Het resultaat: prijsoorlog, copy-paste offertes, frustratie.",
    problem4Title: "Geen klachtrecht",
    problem4Desc: "Contact onbereikbaar? Verkeerd vakgebied? Pech gehad. Bij de meeste platforms is er geen eerlijke oplossing.",
    solutionLabel: "Onze aanpak",
    solutionTitle: "Wat CRAFTFINDUS anders doet",
    solution1Title: "Lead-kwaliteitsscore",
    solution1Desc: "Elke aanvraag wordt automatisch beoordeeld: telefoon geverifieerd, budget opgegeven, beschrijving aanwezig. Alleen aanvragen met score > 60 worden gefactureerd.",
    solution2Title: "Transparante contactprijzen",
    solution2Desc: "Vaste prijzen per contact – vooraf zichtbaar. Geen commissies, geen verborgen kosten.",
    solution3Title: "Max. 3-5 bedrijven per project",
    solution3Desc: "Elke aanvraag gaat naar maximaal 5 geverifieerde bedrijven. Minder concurrentie, hogere sluitingspercentages.",
    solution4Title: "Eerlijk klachtproces",
    solution4Desc: "Contact onbereikbaar? Verkeerd vakgebied? U krijgt uw contactprijs terug – binnen 72 uur, gegarandeerd.",
    solution5Title: "Geverifieerde bedrijven",
    solution5Desc: "Bedrijfsregistratie, verzekering, kredietwaardigheid – onze bedrijven doorlopen een meerstaps verificatieproces.",
    solution6Title: "Eerlijkheidsmechanisme",
    solution6Desc: "Automatische misbruikdetectie, transparantiedashboard en maximale klachtpercentages beschermen de platformkwaliteit.",
    ctaTitle: "Overtuigd?",
    ctaClientBtn: "Project professioneel starten",
    ctaProviderBtn: "Meer gekwalificeerde projecten veiligstellen",
  },
  inquiryPsych: {
    qualityHint: "Hoe nauwkeuriger uw gegevens, hoe beter de bedrijven die u ontvangt.",
    timePromise: "Duurt minder dan 2 minuten",
    matchingHint: "Wij beoordelen uw aanvraag voordat we deze doorsturen naar passende bedrijven.",
    descShort: "Beschrijf uw project alstublieft iets uitvoeriger.",
    descGood: "Zeer goede beschrijving – dit verhoogt uw kansen op snelle offertes.",
    photoHint: "Foto's helpen bij een nauwkeurige inschatting.",
  },
  quality: {
    seoTitle: "Kwaliteitsbelofte – Zo werkt CRAFTFINDUS",
    seoDesc: "Ontdek transparant hoe wij projecten controleren, bedrijven verifiëren, eerlijk factureren en klachten afhandelen.",
    heroLabel: "Onze kwaliteitsbelofte",
    heroTitle1: "Transparantie.",
    heroTitle2: "Niet zomaar een belofte.",
    heroDesc: "We leggen precies uit hoe ons platform werkt – van projectcontrole tot klachtafhandeling.",
    sec1Title: "Hoe projecten worden gecontroleerd",
    sec1Desc: "Elke aanvraag doorloopt onze automatische kwaliteitsengine. Alleen aanvragen met minimaal 60 punten worden doorgestuurd.",
    sec1Item1: "Telefoonnummer geverifieerd (+20 punten)",
    sec1Item2: "Budget opgegeven (+25 punten)",
    sec1Item3: "Projectbeschrijving gecontroleerd (+10 punten)",
    sec1Item4: "Contactgegevens volledig (+10 punten)",
    sec2Title: "Hoe bedrijven worden geverifieerd",
    sec2Desc: "Onze bedrijven doorlopen een meerstaps verificatieproces. Alleen geverifieerde bedrijven ontvangen projectaanvragen.",
    sec2Item1: "Bedrijfsregistratie gecontroleerd (Level 1)",
    sec2Item2: "Aansprakelijkheidsverzekering geverifieerd (Level 2)",
    sec2Item3: "Kredietcontrole geslaagd (Level 3)",
    sec2Item4: "Identiteitsverificatie afgerond (Level 3)",
    sec3Title: "Hoe facturering werkt",
    sec3Desc: "Transparante, voorspelbare kosten. Geen verborgen kosten, geen commissies op opdrachten.",
    sec3Item1: "Vaste prijzen per contact – vooraf zichtbaar",
    sec3Item2: "Flexibele modellen: Flex, Professional, Premium",
    sec3Item3: "Maandelijkse facturering, altijd opzegbaar",
    sec4Title: "Hoe klachten werken",
    sec4Desc: "Eerlijk proces bij terechte klachten. Terugbetaling binnen 72 uur.",
    sec4Item1: "Klacht direct in het dashboard indienen",
    sec4Item2: "Redenen: Onbereikbaar, verkeerd vakgebied, geen echt project",
    sec4Item3: "Terechte klachten worden direct terugbetaald",
    ctaTitle: "Nog vragen?",
    ctaDesc: "Neem contact met ons op of begin direct – wij staan voor transparantie en eerlijkheid.",
    ctaClientBtn: "Project professioneel starten",
    ctaProviderBtn: "Meer gekwalificeerde projecten veiligstellen",
  },
};

export default nl;
